import React, { Component } from 'react'
import $ from 'jquery'
import { Link } from 'react-router-dom'
import * as Common from '../CommonControlls/CommonJs'
import { connect } from 'react-redux'
import AppLogo_Background from '../../images/AppLogo_Background.png'
import Login_Backgroud from '../../images/Login_Backgroud.png'

const mapStateToProps = (store) => {
    return store
}

const mapDispatchToProps = (dispatch) => {
    return {
        ShowAlert: (Settings) => {
            dispatch({ type: 'UpdateAlert', payload: Settings })
        },
        ShowLoader: (Isloading) => {
            dispatch({ type: 'UpdateLoader', payload: Isloading })
        },
        Login: (User) => {
            dispatch({ type: 'UpdatAuth', payload: User })
        },
    }
}

class Login extends Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    render() {
        return (
            <div>
                <div class="login_Container">
                    <div class="side_Image">
                        <img src={AppLogo_Background} style={{ height: '65px' }} />
                        <p>Welcome Back to Riders For Health</p>
                        <img
                            src={Login_Backgroud}
                            style={{ maxHeight: '410.5px', maxWidth: '594.8px' }}
                        />
                    </div>

                    <form class="login_form" onSubmit={this.loginvalidate} novalidate>
                        <div class="Form_PageTitle">Log In</div>

                        <div class="loginform_Content">
                            <p>
                                If you do not have an account{' '}
                                <Link to="/Register" class="basicLink_Tag">
                                    {' '}
                                    Sign up
                                </Link>
                            </p>
                        </div>

                        <div class="loginform_form">
                            <div
                                className="row justify-content-center"
                                style={{ display: 'inline-block', width: '450px' }}
                            >
                                <div class="formInput_Container col-md-12 col-lg-12 col-xl-12 col-12">
                                    <label for="">
                                        <span style={{ color: 'red' }}>* </span>Email / Phone
                                    </label>
                                    <input
                                        autocomplete="off"
                                        type="text"
                                        class="form-control"
                                        placeholder="Enter your email or phone"
                                        id="UserEmail"
                                        autoFocus
                                        required
                                    />
                                </div>

                                <div class="formInput_Container col-md-12 col-lg-12 col-xl-12 col-12">
                                    <label for="">
                                        <span style={{ color: 'red' }}>* </span>Password
                                    </label>
                                    <input
                                        autocomplete="off"
                                        type="password"
                                        class="form-control"
                                        placeholder="Enter your password"
                                        id="Password"
                                        required
                                    />
                                    <i
                                        id="viewpasswordlink"
                                        onClick={(e) => this.updatepasswordviewfun(1)}
                                        class="fa fa-eye viewpasswordicon"
                                        aria-hidden="true"
                                    ></i>
                                    <i
                                        id="hidepasswordlink"
                                        onClick={(e) => this.updatepasswordviewfun(2)}
                                        class="fa fa-eye-slash viewpasswordicon"
                                        style={{ display: 'none' }}
                                        aria-hidden="true"
                                    ></i>
                                </div>
                                <div class="formInput_Container col-md-12 col-lg-12 col-xl-12 col-12">
                                    <Link
                                        to="/Forgot_Password"
                                        class="basicLink_Tag"
                                        style={{ marginRight: '10px', fontWeight: '100' }}
                                    >
                                        Forgot Password
                                    </Link>
                                </div>

                                <div class="loginform_footer formInput_Container col-md-12 col-lg-12 col-xl-12 col-12">
                                    <button type="submit" class="btn LogInForm_btn">
                                        LOG IN
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        )
    }

    componentWillMount() { }
    componentDidMount() {
        // this.props.ShowLoader({Isloading:true})
        // this.props.ShowAlert({Type:0,Msg: "hello"})
        // setTimeout(function(){ $("#Alertmsgbtn").click()}, 50);
    }
    updatepasswordviewfun = (type) => {
        if (type === 1) {
            $('#hidepasswordlink').show()
            $('#viewpasswordlink').hide()
            $('#Password').prop('type', 'text')
        } else {
            $('#hidepasswordlink').hide()
            $('#viewpasswordlink').show()
            $('#Password').prop('type', 'password')
        }
    }

    loginvalidate = (e) => {
        
        e.preventDefault()
        this.props.ShowLoader({ Isloading: true })
        var Parameters = {
            User: $('#UserEmail').val(),
            Password: $('#Password').val(),
            userDeviceId: null,
            appVersion: null,
        }
        Common.Ajax(
            '',
            'Get',
            false,
            Common.APILinks.Login,
            Parameters,
            (resp) => {
                this.props.ShowLoader({ Isloading: false })
                if (resp.status) {
                    var user = {
                        token: resp.token,
                        userobj: resp.userInfo,
                    }

                    this.props.Login(user)

                    if (resp.userInfo.roleId === 4 || resp.userInfo.roleId === 5) {
                        window.location.href = '/NoPageFound'
                    } else {
                        window.location.href = '/LandingLoader'
                    }
                    this.props.history.push('/LandingLoader')
                } else {
                    this.props.ShowAlert({ Type: 0, Msg: resp.message })
                    setTimeout(() => {
                        $('#Alertmsgbtn').click()
                    }, 50)
                }
            },
            (error) => {
                this.props.ShowLoader({ Isloading: false })
                this.props.ShowAlert({
                    Type: 0,
                    Msg: 'Something went wrong, please try again.',
                })
                setTimeout(() => {
                    $('#Alertmsgbtn').click()
                }, 50)
            },
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Login)
